import { render, staticRenderFns } from "./ActorList.vue?vue&type=template&id=fae4f748&scoped=true"
import script from "./ActorList.vue?vue&type=script&lang=js"
export * from "./ActorList.vue?vue&type=script&lang=js"
import style0 from "./ActorList.vue?vue&type=style&index=0&id=fae4f748&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae4f748",
  null
  
)

export default component.exports